<template>
  <section class="min-h-screen bg-background text-primary px-6 py-10">
    <div class="mx-auto max-w-4xl card-primary space-y-6">
      <h1 class="text-3xl font-bold text-gold">Politique de confidentialite</h1>
      <p class="text-sm text-secondary">Version: 2026-07-17</p>

      <div class="space-y-5 text-sm leading-6 text-secondary">
        <div>
          <h2 class="text-gold font-semibold">1. Responsable du traitement</h2>
          <p>
            Le responsable du traitement est TEIXEIRA Philippe, micro-entreprise,
            joignable a l adresse suivante: contact@quiestleplusriche.com.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">2. Donnees collectees</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Donnees d identification: email, pseudonyme genere puis personnalise eventuellement.</li>
            <li>Donnees de compte: mot de passe chiffre, dates de creation et verification de compte.</li>
            <li>Donnees de profil: genre, date de naissance, region, departement, commune si renseignees.</li>
            <li>Donnees de classement: montant cumule, rangs, date de mise a jour du classement.</li>
            <li>Donnees de transaction: montant, statut, fournisseur de paiement, horodatages.</li>
            <li>Donnees de conformite legale: acceptations CGU, CGV, politique de confidentialite et versions associees.</li>
            <li>Donnees techniques: cookies de session et de rafraichissement pour l authentification.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">3. Finalites</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Creation et gestion de compte utilisateur.</li>
            <li>Authentification et securisation des sessions.</li>
            <li>Gestion du classement public et de la position des utilisateurs.</li>
            <li>Traitement des paiements via Stripe et prevention des doubles credits.</li>
            <li>Respect des obligations legales, contractuelles et preuve des consentements.</li>
            <li>Support utilisateur et gestion des incidents techniques.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">4. Bases legales</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Execution du contrat pour la fourniture du service.</li>
            <li>Consentement pour les acceptations contractuelles et certaines donnees de profil.</li>
            <li>Interet legitime pour la securite, la lutte contre la fraude et la continuite du service.</li>
            <li>Obligation legale pour la conservation de certaines traces comptables et contractuelles.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">5. Destinataires</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Exploitant du service (TEIXEIRA Philippe).</li>
            <li>Prestataires techniques d hebergement.</li>
            <li>Prestataire de paiement Stripe pour les transactions.</li>
            <li>Prestataire d envoi d emails transactionnels.</li>
          </ul>
          <p class="mt-2">
            Les donnees de carte bancaire ne sont pas stockees par Quiestleplusriche
            et sont traitees directement par Stripe selon ses propres conditions.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">6. Durees de conservation</h2>
          <ul class="list-disc pl-6 space-y-1">
            <li>Donnees de compte: conservees tant que le compte est actif, puis suppression ou anonymisation dans un delai maximum de 24 mois apres cloture.</li>
            <li>Donnees contractuelles et transactionnelles: conservation pendant 10 ans a des fins comptables et de preuve.</li>
            <li>Preuves de consentement (CGU/CGV/confidentialite): conservation pendant la relation contractuelle puis 5 ans a compter de la fin de relation.</li>
            <li>Tokens techniques de session: conservation pendant leur duree de validite technique uniquement.</li>
          </ul>
        </div>

        <div>
          <h2 class="text-gold font-semibold">7. Droits des personnes</h2>
          <p>
            Vous disposez des droits d acces, rectification, effacement, limitation, opposition et portabilite,
            dans les conditions prevues par le RGPD. Vous pouvez exercer vos droits a
            contact@quiestleplusriche.com.
          </p>
          <p>
            Une reponse vous sera apportee dans les delais prevus par la reglementation applicable.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">8. Cookies</h2>
          <p>
            Le site utilise des cookies techniques necessaires au fonctionnement de l authentification et de la session.
            Ces cookies ne sont pas utilises pour de la publicite comportementale.
          </p>
        </div>

        <div>
          <h2 class="text-gold font-semibold">9. Reclamation</h2>
          <p>
            En cas de desaccord persistant sur le traitement de vos donnees, vous pouvez introduire une reclamation
            aupres de la CNIL.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
